import orderApi from '@/api/order'

const order={
  namespaced:true,
  state:{
    data:[null],
    loading:false,
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    sorter:{},
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,data)=>{
      state.editMsg=data
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    }
  },
  actions:{
    async GetAll({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }       
      try{
        const res=await orderApi.getAll(page)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async Fahuo({ state },input){
      await orderApi.fahuo(input)
      //dispatch('GetAll')
      state
    }
  }
}
export default order